(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5d03"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5d03"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2rxJM", function(module, exports) {

$parcel$export(module.exports, "setLinesWrapper", () => $1c7845f0e1de0887$export$8f060496e19d4bbb);
function $1c7845f0e1de0887$export$8f060496e19d4bbb(lines, callback) {
    // Wrap each line in a .line-wrapper span
    lines.forEach((line)=>{
        const wrapper = document.createElement("span");
        wrapper.classList.add("line-wrapper");
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
    });
    if (typeof callback === "function") callback();
}

});

parcelRegister("71MPf", function(module, exports) {

$parcel$export(module.exports, "initServicesList", () => $51de802038f49ab9$export$22e75ef7dd469ed8);

var $2rxJM = parcelRequire("2rxJM");
function $51de802038f49ab9$export$22e75ef7dd469ed8() {
    const servicesItems = document.querySelectorAll(".services-list-item");
    if (!servicesItems) return;
    servicesItems.forEach((item)=>{
        const line = item.querySelector(".services-list-item-line"), heading = item.querySelector("h3"), description = item.querySelector(".services-list-item-description > p"), button = item.querySelector(".button");
        const headingLines = new SplitType(heading, {
            types: "lines, words",
            tagName: "span"
        });
        const descriptionLines = new SplitType(description, {
            types: "lines",
            tagName: "span"
        });
        let headingEls, descriptionEls;
        (0, $2rxJM.setLinesWrapper)(headingLines.lines, ()=>{
            headingEls = heading.querySelectorAll(".word");
            gsap.set(headingEls, {
                yPercent: 100
            });
        });
        (0, $2rxJM.setLinesWrapper)(descriptionLines.lines, ()=>{
            descriptionEls = description.querySelectorAll(".line");
            gsap.set(descriptionEls, {
                yPercent: 100
            });
        });
        gsap.set(line, {
            scaleX: 0
        });
        gsap.set(button, {
            yPercent: 100
        });
        gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: "top bottom-=20%",
                onEnter: ()=>{
                    const tl = gsap.timeline();
                    tl.to(line, {
                        scaleX: 1,
                        duration: 0.5,
                        ease: "expo.out"
                    }).to(headingEls, {
                        yPercent: 0,
                        stagger: 0.1,
                        duration: 0.5,
                        ease: "expo.out"
                    }, "-=0.25").to(descriptionEls, {
                        yPercent: 0,
                        stagger: 0.05,
                        ease: "expo.out"
                    }, "-=0.25").to(button, {
                        yPercent: 0,
                        duration: 0.3,
                        ease: "expo.out"
                    }, "-=0.25");
                }
            }
        });
    });
}

});


var $2rxJM = parcelRequire("2rxJM");
// Link timelines to scroll position
function $e8430b869ad88317$var$createBrandCoreTrigger(triggerElement, words, isLast, isDelayedStagger, index) {
    if (isDelayedStagger) {
        const height = triggerElement.getBoundingClientRect().height / window.outerHeight;
        words.forEach((word, i)=>{
            const start = i * 20;
            const end = start + 5;
            gsap.fromTo(word, {
                yPercent: 105
            }, {
                yPercent: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: triggerElement,
                    scrub: true,
                    start: `${start}% top`,
                    end: `${end}% top`,
                    markers: false,
                    pin: false
                }
            });
        });
    } else gsap.fromTo(words, {
        yPercent: 105
    }, {
        yPercent: 0,
        stagger: 0.1,
        ease: "none",
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: "top top",
            end: "25% top",
            markers: false,
            pin: false
        }
    });
    if (!isLast) {
        let start, end;
        if (isDelayedStagger) {
            const height = triggerElement.getBoundingClientRect().height / window.outerHeight;
            start = "70% top";
            end = "75% top";
        } else {
            start = "40% top";
            end = "50% top";
        }
        gsap.fromTo(words, {
            yPercent: 0
        }, {
            yPercent: -105,
            stagger: 0.1,
            ease: "none",
            immediateRender: false,
            scrollTrigger: {
                trigger: triggerElement,
                scrub: true,
                start: start,
                end: end,
                markers: false,
                pin: false
            }
        });
    }
    if (isLast) {
        const button = triggerElement.querySelector(".button");
        gsap.set(button, {
            yPercent: 101
        });
        gsap.to(button, {
            yPercent: 0,
            ease: "none",
            immediateRender: false,
            scrollTrigger: {
                trigger: triggerElement,
                scrub: true,
                start: "top top",
                end: "25% top",
                markers: false,
                pin: false
            }
        });
    }
}
function $e8430b869ad88317$export$a6972a2f8f6a85bb() {
    // Split all words on the brand core section
    const brandCoreText = new SplitType(".brand-core-text", {
        types: "lines, words",
        tagName: "span"
    });
    (0, $2rxJM.setLinesWrapper)(brandCoreText.lines, ()=>{
        gsap.set(".brand-core-text .word", {
            yPercent: 100
        });
    });
    const sections = document.querySelectorAll(".brand-core-step");
    sections.forEach((section, i)=>{
        const isDelayedStagger = section.classList.contains("_03");
        const words = section.querySelectorAll(".word");
        const isLast = i === sections.length - 1;
        $e8430b869ad88317$var$createBrandCoreTrigger(section, words, isLast, isDelayedStagger, i);
    });
}



var $2rxJM = parcelRequire("2rxJM");
function $4f8dd14eb30e4f23$export$985150dac2e59f14() {
    const heroSubheadline = new SplitType(".hero-subheadline p", {
        types: "lines",
        tagName: "span"
    });
    (0, $2rxJM.setLinesWrapper)(heroSubheadline.lines, ()=>{});
    gsap.set(".hero-line._02, .hero-line._03", {
        height: 0
    });
    gsap.set(".header", {
        yPercent: -100
    });
    gsap.set(".hero-video-bg", {
        opacity: 0
    });
    gsap.set(".hero-subheadline .line", {
        yPercent: 100
    });
    gsap.set(".section-reels", {
        marginTop: "0rem"
    });
    // gsap.set(".reels-video-container", { y: "12rem" });
    const tl = gsap.timeline();
    const heroVideo = document.querySelector(".hero-video-bg video");
    // const reelsThumb = document.querySelector(".reels-video-thumb");
    // reelsThumb.muted = true;
    // reelsThumb.loop = true;
    // reelsThumb.playsinline = true;
    tl.to(".hero-words-wrapper", {
        y: "-33.33%",
        duration: 1,
        delay: 0.5,
        ease: "expo.inOut"
    }).to(".hero-words-wrapper", {
        y: "-66.66%",
        duration: 1,
        ease: "expo.inOut"
    }).to(".hero-line", {
        height: "25vh",
        duration: 1,
        ease: "power4.inOut"
    }, 2.1).to(".hero-line-spacer", {
        width: "100%",
        duration: 1,
        ease: "power4.inOut"
    }).to(".header", {
        yPercent: 0,
        duration: 1,
        ease: "power4.inOut"
    }, "-=1").to(".hero-subheadline .line", {
        yPercent: 0,
        duration: 0.5,
        ease: "power4.Out",
        stagger: 0.05
    }, "-=0.5").to(".hero-video-bg", {
        opacity: "100%",
        duration: 0.5,
        ease: "power4.Out",
        onStart: ()=>{
            heroVideo.play();
        }
    }, "-=1.5");
    tl.to(".section-reels", {
        marginTop: "-12rem",
        duration: 0.5,
        ease: "power4.Out",
        onStart: ()=>{
        // reelsThumb.play();
        }
    }, "-=0.5");
}


function $1dba3710f09b7657$export$e8ae5caf6764b3bb() {
    const caseStudies = document.querySelectorAll(".case-study-item");
    if (!caseStudies) return;
    const mm = gsap.matchMedia();
    let maskSizeStart = "0vw 0vw";
    let maskSizeEnd = "200vw 200vw";
    mm.add("(min-width: 768px)", ()=>{
        // desktop
        maskSizeStart = "0vw 0vw";
        maskSizeEnd = "200vw 200vw";
    });
    mm.add("(max-width: 767px)", ()=>{
        // mobile
        maskSizeStart = "0vh 0vh";
        maskSizeEnd = "200vh 200vh";
    });
    // Case Studies animations ======================================== //
    caseStudies.forEach((el, i)=>{
        const tl = gsap.timeline();
        const projectId = el.dataset.project;
        const trigger = document.querySelector(`.case-study-spacer[data-project="${projectId}"]`);
        const mask = el.querySelector(".case-study-item-inner");
        const img = el.querySelector(".case-study-item-img");
        if (i === 0) {
            gsap.set(document.querySelector(".case-studies-overlay"), {
                opacity: 1
            });
            gsap.set(document.querySelector(".hero-video-bg-wrapper"), {
                opacity: 1
            });
            gsap.set(document.querySelector(".case-studies-overlay-text"), {
                y: "0rem"
            });
            gsap.set(document.querySelectorAll(".case-study-item-footer"), {
                opacity: 0
            });
            if (window.outerWidth > 767) {
                const wrapper = document.querySelector(".portfolio-sticky-wrapper");
                gsap.set(wrapper, {
                    y: "0rem",
                    width: "30%"
                });
                tl.to(wrapper, {
                    ease: "none",
                    // y: "12rem",
                    width: "100%",
                    scrollTrigger: {
                        trigger: trigger,
                        scrub: true,
                        start: "top bottom",
                        end: "top top"
                    }
                });
            }
            gsap.to(document.querySelectorAll(".case-study-item-footer"), {
                ease: "none",
                opacity: 1,
                scrollTrigger: {
                    trigger: trigger,
                    scrub: true,
                    start: "top bottom",
                    end: "top top"
                }
            });
            gsap.to(document.querySelector(".case-studies-overlay"), {
                ease: "none",
                opacity: 0,
                scrollTrigger: {
                    trigger: trigger,
                    scrub: true,
                    start: "top bottom",
                    end: "top center",
                    onLeave: ()=>{
                        gsap.set(document.querySelector(".case-studies-overlay"), {
                            display: "none"
                        });
                    },
                    onEnterBack: ()=>{
                        gsap.set(document.querySelector(".case-studies-overlay"), {
                            display: "block"
                        });
                    }
                }
            });
            gsap.to(document.querySelector(".case-studies-overlay-text"), {
                ease: "none",
                y: "-10rem",
                scrollTrigger: {
                    trigger: trigger,
                    scrub: true,
                    start: "top bottom",
                    end: "top center"
                }
            });
            gsap.to(document.querySelector(".hero-video-bg-wrapper"), {
                ease: "none",
                opacity: 0,
                scrollTrigger: {
                    trigger: document.querySelector(".section-hero"),
                    scrub: true,
                    start: "top top",
                    end: "bottom top"
                }
            });
            return;
        }
        gsap.set(mask, {
            maskImage: "radial-gradient(circle at 50% 50%, black 50%, rgba(0, 0, 0, 0) 65%)",
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: maskSizeStart
        });
        gsap.set(mask, {
            display: "none"
        });
        tl.to(mask, {
            ease: "none",
            maskSize: maskSizeEnd,
            scrollTrigger: {
                trigger: trigger,
                scrub: true,
                start: "top bottom",
                end: "100vh top"
            }
        });
        gsap.to(mask, {
            scrollTrigger: {
                trigger: trigger,
                scrub: true,
                start: "top bottom",
                end: "bottom top",
                onEnter: ()=>{
                    gsap.set(mask, {
                        display: "block"
                    });
                },
                onEnterBack: ()=>{
                    gsap.set(mask, {
                        display: "block"
                    });
                },
                onLeave: ()=>{
                    gsap.set(mask, {
                        display: "none"
                    });
                },
                onLeaveBack: ()=>{
                    gsap.set(mask, {
                        display: "none"
                    });
                }
            }
        });
        tl.from(img, {
            scale: 1.2,
            opacity: 0.5,
            ease: "none",
            scrollTrigger: {
                trigger: trigger,
                scrub: true,
                start: "top bottom",
                end: "bottom center"
            }
        });
    });
}



var $71MPf = parcelRequire("71MPf");
function $36e8edfd77f3eacd$export$cdf0a0b4b9a28c5f() {
    const wrapper = document.querySelector(".case-studies-progress-inner"), progressBar = document.querySelector(".case-studies-progress"), totalCaseStudies = document.querySelectorAll(".case-study-item-link").length, scroller = document.querySelector(".case-studies-spacer");
    if (!progressBar || !totalCaseStudies) return;
    gsap.fromTo(progressBar, {
        scaleY: 0
    }, {
        scaleY: 1,
        scrollTrigger: {
            trigger: scroller,
            start: "top top",
            end: "bottom bottom",
            scrub: true
        }
    });
}


// set hero sequence
(0, $4f8dd14eb30e4f23$export$985150dac2e59f14)();
document.fonts.ready.then(()=>{
    // Brand Core section
    ScrollTrigger.refresh();
    (0, $e8430b869ad88317$export$a6972a2f8f6a85bb)();
    // Set case studies logic
    (0, $1dba3710f09b7657$export$e8ae5caf6764b3bb)();
    (0, $36e8edfd77f3eacd$export$cdf0a0b4b9a28c5f)();
    (0, $71MPf.initServicesList)();
});

})();
//# sourceMappingURL=home.js.map
